import {
  ChildRemoveEntity,
} from './childRemoveEntity';
import { ChildFamilyName } from './valueObjects/childFamilyName';
import { ChildFamilyNameKana } from './valueObjects/childFamilyNameKana';
import { ChildId } from './valueObjects/childId';
import { ChildName } from './valueObjects/childName';
import { ChildNameKana } from './valueObjects/childNameKana';
import { FacilityId } from './valueObjects/facilityId';
import { ParentId } from './valueObjects/parentId';
import { RemoveDateTime } from './valueObjects/removeDateTime';

import type {
  ChildRemovePropsPub,
  ChildRemovePropsPvt,
} from './childRemoveEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { ChildRemoveJsonPub, ChildRemoveJsonPvt } from '@/types/domain/childApply/entities/childRemoveEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * ChildRemoveFactory
 */
export class ChildRemoveFactory extends FactoryPub<
  ChildRemoveEntity,
  ChildRemovePropsPvt,
  ChildRemoveJsonPvt,
  ChildRemovePropsPub,
  ChildRemoveJsonPub
> {
  comparePub = (
    a: EntityDataPubType<ChildRemoveJsonPvt, ChildRemoveJsonPub>,
    b: EntityDataPubType<ChildRemoveJsonPvt, ChildRemoveJsonPub>,
  ) => {
    const da = new Date(a.data.removeDateTime);
    const db = new Date(b.data.removeDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: ChildRemovePropsPvt,
    propsPub: EntityPubNotNullType<ChildRemovePropsPub>,
  ): ChildRemoveEntity {
    return new ChildRemoveEntity(props, propsPub);
  }

  /**
   * createFromEntityDataPub
   * @param props props
   * @returns Entity
   */
  createFromEntityDataPub(
    props: EntityDataPubNotNullType<ChildRemoveJsonPvt, ChildRemoveJsonPub>,
  ): ChildRemoveEntity {
    return this.create({
      childId: ChildId.create(props.data.childId),
      childName: ChildName.create(props.data.childName),
      childNameKana: ChildNameKana.create(props.data.childNameKana),
      childFamilyName: ChildFamilyName.create(props.data.childFamilyName),
      childFamilyNameKana: ChildFamilyNameKana.create(props.data.childFamilyNameKana),
      facilityId: FacilityId.create(props.data.facilityId),
      parentId: ParentId.create(props.data.parentId),
      removeDateTime: RemoveDateTime.create(new Date(props.data.removeDateTime)),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
